// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".activeToggle___pM2-9{width:74px!important;text-transform:uppercase}.container___vqOtf span[class^=ToggleSwitch__text]{margin-right:8px!important}\n", "",{"version":3,"sources":["webpack://./src/components/ActiveDeactivateToggle/ActivateDeactivateToggle.css"],"names":[],"mappings":"AAAA,sBACI,oBAAA,CACA,wBAAA,CAGJ,mDACQ,0BAAA","sourcesContent":[".activeToggle {\n    width: 74px !important;\n    text-transform: uppercase;\n}\n\n.container span[class^='ToggleSwitch__text'] {\n        margin-right: 8px !important;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activeToggle": "activeToggle___pM2-9",
	"container": "container___vqOtf"
};
export default ___CSS_LOADER_EXPORT___;
